import Styles from './MobileWizards.module.scss'
import { DesignChannel } from 'components/NewFileModal/Types'
import {
  flowA1Schemas,
  flowA2Schemas,
  flowBSchemas,
  flowCSchemas,
  flowDSchemas,
  flowESchemas,
  flowFSchemas,
  flowGSchemas,
  flowISchemas,
  flowZ1Schemas,
  flowZ2Schemas,
  flowK1Schemas,
  flowH1Schemas,
  schematizedTextSchemas,
} from '../schemas/mobileSchemas'

import { FlowA1 } from './MobileWizard/Flows/FlowA1/FlowA1'
import { FlowA2 } from './MobileWizard/Flows/FlowA2/FlowA2'
import { FlowB } from './MobileWizard/Flows/FlowB/FlowB'
import { FlowC } from './MobileWizard/Flows/FlowC/FlowC'
import { FlowD } from './MobileWizard/Flows/FlowD/FlowD'
import { FlowE } from './MobileWizard/Flows/FlowE/FlowE'
import { FlowF } from './MobileWizard/Flows/FlowF/FlowF'
import { FlowG } from './MobileWizard/Flows/FlowG/FlowG'
import { FlowK1 } from './MobileWizard/Flows/FlowK1/FlowK1'
import { FlowI } from './MobileWizard/Flows/FlowI/FlowI'
import { FlowZ1 } from './MobileWizard/Flows/FlowZ1/FlowZ1'
import { FlowZ2 } from './MobileWizard/Flows/FlowZ2/FlowZ2'
import { FlowH1 } from './MobileWizard/Flows/FlowH1/FlowH1'
import { SchematizedTextWizard } from './MobileWizard/Flows/SchematizedTextWizard/SchematizedTextWizard'

import { FlowProps, MobileWizardsProps } from './Types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { MultiStepSchema, WizardType } from '../schemas/Types'
import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'
import { useDefaultContentLanguage } from 'hooks/queries/useDefaultContentLanguage'
import { Spinner } from 'common/Spinner/Spinner'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { DEFAULT_LANGUAGE } from '../Wizard/Form/LanguageInputField/LanguageInput'

export const MobileWizards = ({ channel, onClose, initialValues, ...props }: MobileWizardsProps) => {
  const A1 = flowA1Schemas[channel as DesignChannel]
  const A2 = flowA2Schemas[channel as DesignChannel]
  const B = flowBSchemas[channel as DesignChannel]
  const C = flowCSchemas[channel as ChannelType]
  const D = flowDSchemas[channel as ChannelType]
  const E = flowESchemas[channel as ChannelType]
  const F = flowFSchemas[channel as DesignChannel]
  const G = flowGSchemas[channel as DesignChannel]
  const I = flowISchemas[channel as GenerationType]
  const Z1 = flowZ1Schemas[channel as ChannelType]
  const Z2 = flowZ2Schemas[channel as ChannelType]
  const K1 = flowK1Schemas[channel as ChannelType]
  const H1 = flowH1Schemas[channel as keyof typeof flowH1Schemas]
  const SchematizedText = schematizedTextSchemas[channel as GenerationType]

  const schema = [A1, A2, B, C, D, E, F, G, I, Z1, Z2, K1, H1, SchematizedText].find(Boolean) as
    | MultiStepSchema<WizardType>
    | undefined
  const { data: brandKits, isLoading: isBrandKitsLoading } = useBrandKits()
  const { data: defaultLanguage, isLoading: isLanguageLoading } = useDefaultContentLanguage()

  const wizardValues = {
    brand_kit_id: !!brandKits?.length ? brandKits[0].id : undefined,
    language: defaultLanguage?.language || DEFAULT_LANGUAGE,
    ...initialValues,
  }

  const getFlow = () => {
    if (A1) return FlowA1
    if (A2) return FlowA2
    if (B) return FlowB
    if (C) return FlowC
    if (D) return FlowD
    if (E) return FlowE
    if (F) return FlowF
    if (G) return FlowG
    if (I) return FlowI
    if (K1) return FlowK1
    if (Z1) return FlowZ1
    if (Z2) return FlowZ2
    if (H1) return FlowH1
    if (SchematizedText) return SchematizedTextWizard

    return undefined
  }

  const Flow = getFlow() as React.ComponentType<FlowProps<WizardType>> | undefined

  if (isBrandKitsLoading || isLanguageLoading) {
    return (
      <div className={Styles.container}>
        <Spinner />
      </div>
    )
  }

  if (Flow && schema) {
    return <Flow schema={schema} onClose={onClose} initialValues={wizardValues} {...props} />
  }

  return null
}
